import React from 'react';
import { Card } from './ui';

export const InactivePlan: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <Card className="max-w-lg w-full p-8 text-center">
        {/* Warning icon */}
        <div className="mx-auto mb-6 w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
          <svg className="w-8 h-8 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
        </div>

        <h1 className="text-xl font-bold text-gray-900 mb-3">Privacy Center Unavailable</h1>
        <p className="text-gray-600 leading-relaxed mb-6">
          This privacy center is currently deactivated. Please contact your organization administrator
          to reactivate the service.
        </p>
        <p className="text-sm text-gray-500">
          If you believe this is an error, please reach out to your organization's support team.
        </p>
      </Card>
    </div>
  );
};
